export default "__VITE_PUBLIC_ASSET__3187e1ac__"